<template>
  <article class="service-thumbnail">
    <div class="service-thumbnail-content">
      <!--      <img
                :src="imgSrc"
                alt="Medical service illustration"
                class="service-thumbnail-image"
            />-->
      <div :style="`background-image: url(${imgSrc})`" class="service-thumbnail-image"></div>
      <div class="service-thumbnail-info">
        <!--        <span class="service-thumbnail-number">{{ number }}</span>-->
        <h2 class="service-thumbnail-title">{{ title }}</h2>
        <CircleButton :theme="'solid-blue'" class="circle-button"/>


      </div>
    </div>
  </article>
</template>

<script>
import CircleButton from "@/components/Common/Buttons/CircleButton.vue";

export default {
  name: 'ServiceThumbnail',
  components: {
    CircleButton
  },
  props: {
    imgSrc: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.service-thumbnail {
  border-radius: 20px;
  background-color: #ddd1cb;
  overflow: hidden;
  display: flex;
  height: 100%;
  width: 220px;
  max-width: 285px;
  flex-direction: column;
  color: #fff;
  justify-content: center;
  cursor: pointer;
  font-family: $font-regular;

  &:hover {
    transition: 1s ease-in-out;

    .service-thumbnail-image {
      opacity: 100%;
    }

    .service-thumbnail-info {
      background: linear-gradient(0deg, rgba(221, 209, 203, 0) -23.07%, #1892ac 100%);
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    }

    .circle-button {
      display: block;
    }

  }
}

.circle-button {
  display: none;
  position: absolute;
  bottom: 5%;
}

.service-thumbnail-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  aspect-ratio: 0.73;
  width: 100%;
  justify-content: center;
}

.service-thumbnail-image {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  opacity: 15%;
  transition: 0.3s ease-in-out;
}

.service-thumbnail-info {
  position: relative;
  background: linear-gradient(
          180deg,
          rgba(221, 209, 203, 0) -23.07%,
          rgba(206, 169, 151, 0.4) 100%
  );
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: start;
  padding: 20px 20px 0;
  text-align: left;

}

.service-thumbnail-number {
  font-size: 20px;
}

.service-thumbnail-title {
  margin: 11px 0 0px;
  font-size: 20px;
}

@media screen and (min-width: 768px) {
  .service-thumbnail {
    max-width: 385px;
    width: 100%;
  }

}

</style>